export const events = {
  USER_COOKIE_CONSENT: 'user_cookie_consent',
};
